/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const SeverityType = {
    Unknown: 'Unknown',
    Hint: 'Hint',
    WarningLow: 'WarningLow',
    WarningHigh: 'WarningHigh',
    ErrorLow: 'ErrorLow',
    ErrorHigh: 'ErrorHigh',
    ErrorFatal: 'ErrorFatal',
    ErrorFatalDevice: 'ErrorFatalDevice'
} as const;
export type SeverityType = typeof SeverityType[keyof typeof SeverityType];


export function SeverityTypeFromJSON(json: any): SeverityType {
    return SeverityTypeFromJSONTyped(json, false);
}

export function SeverityTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): SeverityType {
    return json as SeverityType;
}

export function SeverityTypeToJSON(value?: SeverityType | null): any {
    return value as any;
}

/**
 * Check if a given object implements the SeverityType interface.
 */
 export function instanceOfSeverityType(value: any): value is SeverityType {
    return Object.values(SeverityType).includes(value)
}

